import { format, addDays } from 'date-fns';
import { MenuItem } from "@mui/material";

import Text from "../../components/Text";
import Spinner from "../../components/Spinner";
import Dropdown from "../../components/Dropdown";
import SearchBox from "../../components/SearchBox";
import FilterBar from "../../components/FilterBar";
import { Row, Col } from "../../components/Flexbox";
import WeeklyRolesTable from "../../components/WeeklyRolesTable";
import SelectableContainer from "../../components/SelectableContainer";
import { useTheme } from "../../scripts/functions/ThemeProvider";
import { useWeeklyRolesNormalizer } from "../../containers/WeeklyRolesNormalizer";

const Roles = () => {
    const {theme} = useTheme();

    const {rows, opciones, weekOffset, monday, search, pendingCount, incompleteCount, onlyIncomplete, loading, isFetching, isSaving, dayOptions, fromDate,
        fetchRoles, requestSort, getIcon, updateField, changeWeek, discardEdits, setSearch, setOnlyIncomplete, setFromDate, save} = useWeeklyRolesNormalizer();
    const canSave = !isSaving && incompleteCount === 0;

    const weekLabel = `${format(monday, 'dd/MM')} - ${format(addDays(monday, 6), 'dd/MM')}`;

    return (
        <Col style={{width: '100%', flex: 'none', alignItems: 'flex-start', paddingLeft: 64, paddingRight: 64, paddingTop: 64}}>
            <Row style={{justifyContent: 'space-between', width: '100%', maxHeight: '36px', gap: '32px', marginBottom: '16px', flexWrap: 'wrap'}} mobileStyle={{gap: 8}}>
                <Text size='21px' color={theme.Black}>Roles</Text>
                <Col style={{alignItems: 'end'}} mobileStyle={{alignItems: 'flex-start', width: '100%', gap: 8}}>
                    <Text color={theme.SEVENB} size={15} style={{whiteSpace: 'nowrap'}}>Semana {weekLabel}</Text>
                    <Text onClick={() => !isFetching && fetchRoles()} style={{cursor: 'pointer'}} color={theme.Magenta} size={15}>Actualizar</Text>
                </Col>
            </Row>
            <FilterBar style={{width: '100%', maxHeight: '64px', gap: '16px', alignItems: 'center', marginTop: '32px', justifyContent: 'space-between'}}>
                <Row style={{flex: 1, justifyContent: 'flex-start', maxHeight: '36px', gap: 4}}>
                    <SelectableContainer theme={theme} text="Semana actual" active={weekOffset === 0} onClick={() => changeWeek(0)} style={{marginBottom: 0}}/>
                    <SelectableContainer theme={theme} text="Semana siguiente" active={weekOffset === 1} onClick={() => changeWeek(1)} style={{marginBottom: 0}}/>
                    <SearchBox theme={theme} style={{width: 'auto', flex: 'none', height: 36}} placeholder="Nómina, nombre o máquina" value={search} onChange={setSearch}/>
                </Row>
                <Row style={{flex: 'none', justifyContent: 'end', maxHeight: '36px', gap: 16}}>
                    {(incompleteCount > 0 || onlyIncomplete) && (
                        <Text style={{cursor: 'pointer', whiteSpace: 'nowrap'}} onClick={() => setOnlyIncomplete(!onlyIncomplete)} color={theme.Orange} size={15}>
                            {onlyIncomplete ? 'Ver todos' : `${incompleteCount} incompleto(s)`}
                        </Text>
                    )}
                    {pendingCount > 0 && (
                        <Text style={{cursor: 'pointer', whiteSpace: 'nowrap'}} onClick={discardEdits} color={theme.Lao} size={15}>Descartar {pendingCount} cambio(s)</Text>
                    )}
                    <Text color={theme.SEVENB} size={15} style={{whiteSpace: 'nowrap'}}>Periodo</Text>
                    <Dropdown theme={theme} value={fromDate} onChange={setFromDate} style={{width: '180px', height: '36px'}}>
                        {dayOptions.map(day => (
                            <MenuItem key={day.value} value={day.value} style={{textTransform: 'capitalize'}}>{day.label}</MenuItem>
                        ))}
                    </Dropdown>
                    {/* Disabled while there are incomplete rows; save() also explains why if clicked */}
                    <Text style={{cursor: canSave ? 'pointer' : 'default', whiteSpace: 'nowrap', opacity: canSave ? 1 : 0.5}} onClick={() => !isSaving && save()} color={theme.Magenta} size={15}>{isSaving ? "Guardando..." : "Guardar"}</Text>
                </Row>
            </FilterBar>
            <Col style={{width: '100%', height: '100%', alignItems: 'start', justifyContent: 'start', position: 'relative', marginTop: 32}}>
                <WeeklyRolesTable rows={rows} opciones={opciones} theme={theme} requestSort={requestSort} getIcon={getIcon} onChange={updateField}/>

                {(loading || isFetching) &&
                    <Col style={{position: 'absolute', top: 0, left: 0, zIndex: 10, justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', backgroundColor: theme.Alfalfa}}>
                        <Spinner theme={theme}/>
                    </Col>
                }
            </Col>
        </Col>
    )
}

export default Roles;
